import { store } from '@/decorators/store';
import { UnitTemplate } from '@/entities/UnitTemplate';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'UnitTemplate' })
export class UnitTemplateStore extends AbstractEntityStore<UnitTemplate> {
  protected entityIdKey = 'id';
  protected entityValueKey = 'name';
}
